<template>
	<div class="locationSearch">
		<v-select label="display_name" :options="locations"  @search="searchLocations" v-model="selected_location" :filterable="false" :placeholder="placeholder">
			<template slot="no-options">
				Searching your previous favorite locations.
			</template>
			<template slot="option" slot-scope="location">
				<div  class="notranslate" translate="no" v-bind:class="{ 'location-search-favorite': location.favorite, 'location-search-not-favorite': !location.favorite }">
					<i class="fa fa-star" v-if="location.favorite" /> 
					{{ location.display_name }}
					<small v-if="!location.display_name">{{ location.name }}</small>
					<br v-if="location.type_data && location.type_data.name == 'County'" />
					<small v-if="location.type_data && location.type_data.name == 'County'">{{ location.type_data.name }}</small>
				</div>
			</template>
		</v-select>
		<div class="location-parent notranslate" v-if="selected_location_parent" translate="no">
			in {{selected_location_parent.display_name}}
		</div>
	</div>
</template>

<script>
export default {
	name: 'LocationSearch',
	props: ['value', 'current_user', 'placeholder'],
	data: function(){
		return {
			selected_location_parent: null,
			selected_location: this.value ? this.value : null,
			locations:[],
			default_locations:null,
			placeholder: this.placeholder
		};
	},
	mounted: function(){
		var self = this;
		this.setParentLocation();
		this.getDefaultLocations();
		this.GetAPIUser(function(user){
			if (!user) {
				return;
			}
			self.getDefaultLocations(user);
		}, true);
	},
	watch: {
		value:function(val){
			this.selected_location = val;
		},
		// 'current_user': function(val){
		// 	this.getDefaultLocations(val);
		// },
		selected_location: function () {
			this.$emit('input', this.selected_location);
			this.setParentLocation();
		},
	},
	methods:{
		getDefaultLocations: function(user){
			if (!user) {
				return;
			}
			var self = this;
			this.API({
				endpoint: 'locations',
				querystring: "&include[]=type.*&previous=true&selections=true&per_page=1000",
				funcThen: function(response){
					for (var i = 0; i < response.data.locations.length; i++) {
						response.data.locations[i].type_data = response.data.location_types.find(l => l.id == response.data.locations[i].type)
					}
					self.locations = response.data.locations;
				}
			});
		},
		setParentLocation: function(){
			if (this.selected_location) {
				var self = this;
				if (self.selected_location.parent) {
					this.API({
						endpoint: 'locations/' + self.selected_location.parent,
						funcThen: function(response){
							self.selected_location_parent = response.data.location;
						},
					});
				}
				else{
					self.selected_location_parent = null;
				}
			}
		},
		searchLocations: function(search, loading){
			if (search == "") {
				this.locations = this.default_locations;
			}
			else{
				loading(true);
				var self = this;
				this.API({
					endpoint: 'locations',
					querystring: "&include[]=type.*&previous=true&selections=true&per_page=1000&search="+search,
					funcThen: function(response){
						for (var i = 0; i < response.data.locations.length; i++) {
							response.data.locations[i].type_data = response.data.location_types.find(l => l.id == response.data.locations[i].type)
						}
						self.locations = response.data.locations;
					},
					funcAfterThen: function(){
						loading(false);
					}
				});
			}
		},
	},
}
</script>


// WEBPACK FOOTER //
// src/components/LocationSearch.vue